import { httpClient, apiLinks } from '@app/utils';
import { DataModules, Module, ParamsGetModule } from '../models/module';
import { SystemModule } from '@admin/manage-customer/models/user';

const getModules = async (params: ParamsGetModule): Promise<DataModules> => {
  const result = await httpClient.get<DataModules>({
    url: apiLinks.admin.moduleManagement.getSearch,
    params,
  });
  return result.data;
};

const createModule = async (model: FormData): Promise<Module> => {
  const result = await httpClient.post<Module>({
    url: apiLinks.admin.moduleManagement.module.create,
    data: model,
    contentType: 'multipart/form-data',
  });
  return result.data;
};

const getModuleDetail = async (id: string): Promise<Module> => {
  const result = await httpClient.get<Module>({
    url: apiLinks.admin.moduleManagement.module.getdetail + id,
  });
  return result.data;
};

const getModuleCurrent = async (): Promise<SystemModule[]> => {
  const result = await httpClient.get<SystemModule[]>({
    url: apiLinks.admin.moduleManagement.module.getModuleCurrent,
  });
  return result.data;
};

const getModuleImage = async (imageName: string): Promise<void> => {
  const result = await httpClient.get<void>({
    url: apiLinks.admin.moduleManagement.module.getImage,
    params: { imageName },
  });
  return result.data;
};

const updateModule = async (id: number, model: FormData): Promise<Module> => {
  const result = await httpClient.put<Module>({
    url: apiLinks.admin.moduleManagement.module.update + id,
    data: model,
    contentType: 'multipart/form-data',
  });
  // console.log(result.data);
  return result.data;
};

const updateModuleStatus = async (
  id: number,
  data: FormData,
): Promise<Module> => {
  const response = await httpClient.put<Module>({
    url: apiLinks.admin.moduleManagement.module.updateStatus + id,
    data,
    contentType: 'multipart/form-data',
  });

  return response.data;
};

export const moduleServices = {
  getModules,
  createModule,
  updateModule,
  getModuleDetail,
  getModuleImage,
  getModuleCurrent,
  updateModuleStatus,
};
